export const B2bFaq = [
  {
    title: "¿Cómo puedo contratar el servicio de luz con Fiva?",
    content:
      "Contratar a través de Fiva es sencillo. Adjunta tu última factura de luz y te ofreceremos una comparativa personalizada con las mejores opciones del mercado. Elige la tarifa que más te convenga y completa el proceso de contratación online de tu nueva compañía, todo desde nuestra plataforma.",
  },
  {
    title: "¿Qué ventajas ofrece Fiva?",
    content:
      "Con nuestro comparador, obtendrás una selección personalizada de tarifas de luz, ahorrando entre un 15% y 40% en tus facturas. Comparamos más de 90 ofertas para darte la mejor opción según tus necesidades específicas.",
  },

  {
    title: "¿Tiene algún coste el proceso de cambio de compañía eléctrica?",
    content:
      "El proceso de cambio a través de Fiva no tiene coste. Facilitamos la comparación y el cambio de compañía de luz sin gastos adicionales, asegurando tu ahorro desde el inicio.",
  },

  {
    title: "¿Corro el riesgo de quedarme sin luz durante el cambio?",
    content:
      "No hay riesgo de interrupción en tu suministro de luz durante el proceso de cambio. El cambio es un proceso administrativo que no afecta la continuidad de tu servicio eléctrico. Con Fiva, puedes cambiar de compañía de manera segura y sin preocupaciones.",
  },

  {
    title: "¿Cómo elegir la tarifa de luz más adecuada para mi empresa o pyme?",
    content:
      "Fiva te asiste en la elección de la tarifa más adecuada analizando el consumo eléctrico de tu empresa y la potencia contratada. Consideramos el perfil de consumo de tu negocio y comparamos las diferentes opciones del mercado, ofreciéndote soluciones personalizadas que se ajusten a tus necesidades específicas y te ayuden a maximizar el ahorro.",
  },

  {
    title:
      "¿Qué aspectos debo considerar al seleccionar una tarifa eléctrica para mi negocio?",
    content:
      "Al utilizar Fiva para seleccionar una tarifa eléctrica para tu empresa, es importante tener en cuenta tu consumo mensual, los tipos de maquinaria utilizados y la potencia contratada. Nuestro servicio te ayuda a evaluar si prefieres una tarifa fija para una previsibilidad en las facturas o una variable para posibles ahorros. Fiva se encarga de comparar estas opciones y te asesora en la decisión más rentable.",
  },
]

export const B2cFaq = [
  {
    title: "¿Cómo puedo contratar el servicio de luz con Fiva?",
    content:
      "Contratar a través de Fiva es sencillo. Adjunta tu última factura de luz y te ofreceremos una comparativa personalizada con las mejores opciones del mercado. Elige la tarifa que más te convenga y completa el proceso de contratación online de tu nueva compañía, todo desde nuestra plataforma.",
  },
  {
    title: "¿Qué ventajas ofrece Fiva?",
    content:
      "Con nuestro comparador, obtendrás una selección personalizada de tarifas de luz, ahorrando entre un 15% y 40% en tus facturas. Comparamos más de 90 ofertas para darte la mejor opción según tus necesidades específicas.",
  },

  {
    title: "¿Tiene algún coste el proceso de cambio de compañía eléctrica?",
    content:
      "El proceso de cambio a través de Fiva no tiene coste. Facilitamos la comparación y el cambio de compañía de luz sin gastos adicionales, asegurando tu ahorro desde el inicio.",
  },

  {
    title: "¿Corro el riesgo de quedarme sin luz durante el cambio?",
    content:
      "No hay riesgo de interrupción en tu suministro de luz durante el proceso de cambio. El cambio es un proceso administrativo que no afecta la continuidad de tu servicio eléctrico. Con Fiva, puedes cambiar de compañía de manera segura y sin preocupaciones.",
  },
  {
    title:
      "¿Qué debo hacer para dar de alta el suministro de luz en una nueva vivienda?",
    content: `Para dar de alta el suministro de luz en una nueva vivienda, 
    Fiva te guía a través del proceso que incluye elegir una compañía eléctrica, 
    decidir la tarifa y la potencia, y proporcionar la documentación necesaria como el Boletín Eléctrico. 
    Nos encargamos de facilitar el proceso, asesorándote en cada paso para asegurar una alta eficiente y adecuada a tus necesidades.`,
  },
  {
    title: "¿Cómo cambio el titular del contrato de la luz?",
    content: `Cambiar el titular del contrato de la luz es un trámite sencillo con Fiva. Ya sea porque te mudas a una nueva vivienda o por otros motivos, te asistimos en el proceso, que incluye proporcionar datos personales del nuevo titular y, en algunos casos, modificar las condiciones del contrato. Te aseguramos un cambio de titularidad sin complicaciones y adaptado a tus circunstancias personales.`,
  },
]

export const CCPPFaq = [
  {
    title:
      "¿Cómo se puede ahorrar en la factura de luz de una comunidad de propietarios?",
    content: `Ahorrar en la factura de luz de una comunidad de propietarios es posible mediante la optimización de la potencia contratada, 
     la implementación de medidas de eficiencia energética como iluminación LED, y la elección de tarifas con discriminación horaria. Fiva te ofrece un estudio detallado y asesoramiento personalizado para implementar estas medidas y seleccionar la tarifa que mejor se adapte a las necesidades de la comunidad, maximizando el ahorro.`,
  },
  {
    title:
      "¿Qué factores influyen en el consumo de luz en una comunidad de vecinos?",
    content: `Los factores que influyen en el consumo de luz en una comunidad de vecinos incluyen las dimensiones del edificio, el número de viviendas, la presencia de ascensor, y las áreas comunes como jardines o piscinas. 
      Fiva te ayuda a identificar estos factores y a evaluar su impacto en el consumo total, proporcionando recomendaciones para optimizar el uso de la energía y reducir costes.`,
  },

  {
    title:
      "¿Qué rol juega un administrador de fincas en la gestión del consumo energético de una comunidad?",
    content: `El administrador de fincas juega un papel crucial en la gestión del consumo energético de una comunidad. Fiva colabora con estos profesionales para analizar el consumo actual, identificar áreas de mejora y aplicar estrategias de ahorro energético. 
     El administrador es clave en la implementación de estas medidas y en la comunicación con los residentes para fomentar prácticas de consumo eficientes.`,
  },

  {
    title: "¿Corro el riesgo de quedarme sin luz durante el cambio?",
    content:
      "No hay riesgo de interrupción en tu suministro de luz durante el proceso de cambio. El cambio es un proceso administrativo que no afecta la continuidad de tu servicio eléctrico. Con Fiva, puedes cambiar de compañía de manera segura y sin preocupaciones.",
  },
  {
    title: "¿Es necesario instalar maxímetros en la comunidad de vecinos?",
    content: `La instalación de maxímetros en comunidades de vecinos es común, especialmente en aquellas con suministros de potencias superiores a 15kW, como los que tienen ascensores. Fiva te asesora sobre la necesidad y beneficios de instalar un maxímetro, que ayuda a controlar y limitar el consumo de energía, evitando sobrecargas y optimizando los costes.`,
  },
  {
    title:
      "¿Qué opciones de tarifas de gas existen para comunidades de vecinos?",
    content: `Para las comunidades de vecinos, Fiva explora diversas opciones de tarifas de gas, 
    adecuadas tanto para calefacción central como para otros usos comunes. Estas pueden incluir tarifas planas o variables, 
    dependiendo de las necesidades y patrones de consumo de la comunidad. Te asesoramos en la elección de la tarifa más eficiente, 
    considerando aspectos como el volumen de consumo y las características de la instalación de gas de la comunidad.`,
  },
]

export const FreelanceFaq = [
  {
    title: "¿Necesito tener experiencia en el sector energético?",
    content: `No, en Fiva hemos simplificado tanto la comparativa que puedes hacerlo sin experiencia previa. Además, tendrás un asesor ayudándote siempre que lo necesites.`,
  },
  {
    title: "¿Qué tipo de soporte recibiré como colaborador?",
    content: `Como colaborador de Fiva, recibirás soporte continuo a través de nuestro equipo de asesores expertos. Te proporcionaremos las herramientas y formación necesarias para que puedas ofrecer el mejor servicio a tus clientes.`,
  },
  {
    title: "¿Cómo puedo empezar a vender productos energéticos con Fiva?",
    content: `Para empezar a vender productos energéticos con Fiva, solo necesitas registrarte en nuestra plataforma. Te guiaremos a través de los primeros pasos y te proporcionaremos toda la información y recursos necesarios para comenzar.`,
  },
  {
    title: "¿Cuáles son los beneficios de ser un colaborador de Fiva?",
    content: `Ser colaborador de Fiva te permite diversificar tu cartera de productos, acceder a comisiones atractivas y recibir formación continua. Además, podrás ofrecer a tus clientes soluciones energéticas innovadoras y eficientes.`,
  },
  {
    title: "¿Qué tipos de productos energéticos puedo vender?",
    content: `Con Fiva, puedes vender una amplia gama de productos energéticos, incluyendo cargadores ultra rápidos, instalaciones solares y baterías solares. Te proporcionamos todo el material de marketing y soporte técnico para que puedas presentar estos productos a tus clientes de manera efectiva.`,
  },
  {
    title: "¿Cómo gestiono las ofertas y tarifas para mis clientes?",
    content: `Fiva te facilita la gestión de ofertas y tarifas a través de nuestra plataforma en línea. Podrás comparar diferentes opciones y seleccionar las que mejor se adapten a las necesidades de tus clientes, garantizando siempre el mejor precio y servicio.`,
  },
]
